// @flow

import React from 'react';
import NoData from './NoData';
import styled from 'styled-components';
import { StyledTable } from './StyledTable';
import { priceGenerator, __isNil } from '../../../utils';
import { TextWithTooltip } from '../';

type Props = {
  cols: Array,
  tBodyData: Array,
  showIndex?: Boolean,
};

const formatValue = (fields = [], row, col) => {
  const _key = col?.key;

  if (fields.includes(_key)) {
    return priceGenerator(row[_key]);
  }

  return __isNil(row[_key]) ? '-' : row[_key];
};

const Table = function (props: Props) {
  const { cols, tBodyData, showIndex, className } = props;
  return (
    <>
      <StyledTable className={`font-xs-xsm font-sm-sm mb-0 ${className}`}>
        <thead className="bg-secondary text-white ">
          <tr>
            {showIndex && <th scope="col">ردیف</th>}
            {cols.map((col, i) => (
              <th key={i} scope="col">
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tBodyData.map((row, index) => (
            <tr key={index}>
              {showIndex && <td scope="row">{index}</td>}
              {cols.map((col, i) => {
                return (
                  <td key={i}>
                    <TextWithTooltip
                      maxCharacter={30}
                      color="gray"
                      size="lg"
                      truncated
                      id={`item_${i}`}
                    >
                      {formatValue(['price', 'totalPrice'], row, col)}
                    </TextWithTooltip>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
        {/* <tfoot></tfoot> */}
      </StyledTable>
      {!tBodyData.length && <NoData />}
    </>
  );
};

export default Table;
